<template>
  <div class="map-legend">
    <v-btn :class="{ 'd-none': display }" @click="display = true">
      <v-icon class="mr-1">mdi-information</v-icon
      >{{ $t("map-legend-btn-label") }}
    </v-btn>
    <v-card class="map-legend__card" :class="{ 'd-none': !display }">
      <v-btn
        icon
        class="map-legend__close-button d-block d-sm-none"
        @click="display = false"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-card-text>
        <v-row>
          <v-col
            v-for="(color, index) in ownersColor"
            :key="`color-${index}`"
            cols="6"
            sm="4"
            class="map-legend__item"
          >
            <div
              :class="{ selected: index === ownerFilter }"
              @click="toggleOwnerFilter(index)"
            >
              <v-icon :color="color">mdi-map-marker</v-icon>{{ index }}
            </div>
          </v-col>
          <v-col cols="6" sm="4">
            <v-icon color="#3fb1ce">mdi-map-marker</v-icon
            >{{ $t("map-legend-others").toUpperCase() }}
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ownersColor from "@/services/ownersColor.json";

export default {
  name: "MapLegend",

  data() {
    return {
      ownersColor: ownersColor,
      display: true
    };
  },

  computed: {
    ownerFilter: {
      get() {
        return this.$store.getters["filters/owner"];
      },
      set(value) {
        this.$store.commit("filters/setOwner", value);
      }
    }
  },

  methods: {
    toggleOwnerFilter(owner) {
      if (owner !== this.ownerFilter) {
        this.$store.commit("filters/setOwner", owner);
      } else {
        this.ownerFilter = null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables";
.map-legend {
  position: absolute;
  bottom: 40px;
  left: 10px;
  right: 10px;
  max-width: 400px;

  .map-legend__card {
    position: absolute;
    bottom: 0;
    left: 0;

    .map-legend__item {
      padding: 4px 4px;
      cursor: pointer;

      @media #{map-get($display-breakpoints, 'xs-only')} {
        padding-right: 28px;
      }

      div {
        border: 1px solid transparent;
        border-radius: 28px;
        user-select: none;
        height: 100%;
        padding: 12px 8px;

        @media #{map-get($display-breakpoints, 'xs-only')} {
          padding: 12px 8px;
        }

        &:hover {
          border-color: darken(white, 30%);
        }

        &.selected {
          border-color: darken(white, 30%);
          @include elevation(2);
        }
      }
    }

    .map-legend__close-button {
      position: absolute;
      top: 5px;
      right: 5px;
    }
  }
}
</style>
